import { Component, inject } from '@angular/core'
import { RouterOutlet } from '@angular/router'

import { Toast } from 'primeng/toast'

import { NavigationHistoryProvider } from '@ti/core/common/services'

import { TspAdminMenuComponent } from './menu/menu.component'

@Component({
  selector: 'app-tsp-admin-layout',
  templateUrl: 'layout.component.html',
  styleUrls: ['layout.component.scss'],
  imports: [Toast, RouterOutlet, TspAdminMenuComponent],
})
export class TspAdminLayoutComponent {
  protected readonly navigationHistoryProvider = inject(NavigationHistoryProvider)
}
